import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

export const LeaderboardMap = {
  go_to_review: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'go_to_review'),
  open_embed_modal: TrackingEvent.actionCompleted(TrackingConstant.ACTION_EMBED_CONTENT, 'open_embed_modal'),
};
